// Redux Accessories Types
export const ACCESSORIES_FETCH_SUCCESS = "ACCESSORIES_FETCH_SUCCESS";
export const ACCESSORIES_RESET = "ACCESSORIES_RESET";